<!-- NestedDrawer.vue -->
<template>
  <v-navigation-drawer
    id="nestedDrawer"
    v-model="localNestedDrawer"
    class="print-margin"
    disable-resize-watcher
    :class="{'drawerOpen' : localNestedDrawer}"
    :width=" mobile ? width-60 : userJS.nestedDrawerWidth.value"
    style="left: 60px; z-index: 100;"
    permanent
    persistent
    touchless
  >
    <!-- 좌측 메뉴 영역 너비 조절 마우스 드래그 바 -->
    <div
      v-if="!mobile"
      id="dragbarForMenu"
      float="right"
      @mousedown="startDragging"
    >
      <v-icon
        id="dragbarForMenu-icon"
        size="small"
        color="#DBDBDB"
      >
        mdi-dots-vertical
      </v-icon>
    </div>

    <v-card
      v-show="props.tab=='option-1'"
      flat
    >
      <v-toolbar
        background-color="background"
        color="background"
        class="pa-2 d-flex align-center"
        height="42"
      >
        <div class="text-subtitle-1 font-weight-bold">
          기사목록
        </div>

        <v-spacer />

        <!-- articleList.options 길이만큼 칩 생성
          - 옵션이 0개면 chip-group 자체 숨김
          - 옵션이 1개면 .single-option 클래스로 타원형 스타일 적용 -->
        <v-chip-group
          v-if="articleListOptions.length"
          v-model="articleListSelection"
          class="nestedDrawerChipGroup"
          :class="{ 'single-option': articleListOptions.length === 1 }"
          selected-class="txt-co"
          mandatory
        >
          <v-chip
            v-for="opt in articleListOptions"
            :key="opt.key"
            :ripple="false"
            class="me-0"
            size="small"
            :prepend-icon="opt.icon"
            :value="opt.key"
            variant="outlined"
          >
            {{ opt.label }}
          </v-chip>
        </v-chip-group>
      </v-toolbar>

      <v-divider />

      <div
        class="scroll-container1 scroll-container2 noHeaderHeight"
        style="overflow-y:scroll;"
      >
        <v-card
          v-if="articleListSelection === 'LIST_VIEW'"
          flat
        >
          <!-- v-model:opened="open" 가 eslint에 의해 사용안됨. 대신 setArticleListGroup(page) 함수로 구현. -->
          <v-list
            id="articleList-customize"
            :opened="localOpen"
            density="compact"
            nav
            lines="one"
            open-strategy="multiple"
          >
            <v-list-group
              v-for="(page, index) in localNews1"
              :key="index"
              v-model="localOpen"
              :value="page.Serial"
            >
              <template #activator="{ props }">
                <v-list-item
                  v-bind="props"
                  :ripple="false"
                  @click="setArticleListOpenGroup(page.Serial);"
                >
                  <div
                    :id="'group-'+index"
                    class="d-flex bold-text"
                    :class="{ 'selected-news': selectedGroupIndex == index }"
                    @click.stop="handleListGroupClick(index, page.Serial)"
                  >
                    {{ page.Name+'('+page.Category+')' }}
                  </div>
                </v-list-item>
              </template>

              <!-- 기사 제목 : 클릭 시 지면의 기사 하이라이트, 기사 상세보기 창 활성화 -->
              <!-- v-list-item--active : 북마크 선택 시 기사 목록 선택 상태 활성화 -->
              <v-list-item
                v-for="(oneArticle, i) in page.Articles"
                :id="'list-'+index+'-'+i"
                :key="i"
                :ripple="false"
                :value="oneArticle.Serial"
                :active="props.selectedArticleSerial == oneArticle.Serial"
                @click.stop="selectedGroupIndex = index; $emit('handle-list-click', oneArticle.Serial, page.idx, undefined, 'articleList');"
              >
                <template #append>
                  <v-icon
                    v-if="scrapSerialList && scrapSerialList.includes(oneArticle.Serial)"
                    size="small"
                    variant="text"
                    color="primary"
                  >
                    mdi-bookmark
                  </v-icon>
                </template>
                <template #title>
                  <span v-html="oneArticle.Title" />
                </template>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
        <!-- 기사목록 / 썸네일 -->
        <v-card
          v-if="articleListSelection === 'THUMBNAIL_VIEW'"
          flat
        >
          <v-row class="ma-auto pa-2 card_li">
            <ul
              class="d-flex flex-wrap"
              style="width: 277px"
              :class="[props.pageSide === 1 ? 'justify-space-between' : 'justify-center']"
            >
              <li
                v-for="(thumbImages, index) in props.thumbnailBind"
                :id="'thumbnail-list-'+index"
                :key="index"
                class="d-flex flex-sm-row"
                :style="{flex: props.pageSide === 1 ? (!thumbImages[0].doublepage ? '0 0 50%' : '0 0 100%') : '0 0 100%'}"
                @click="handleListGroupClick(index);"
              >
                <!-- 양면인 경우 + 1면인 경우 : 속지 -->
                <div
                  v-if="props.pageSide === 2 && index == 0"
                  class="cursor-pointer endpaper-first-thm"
                >
                  <img
                    class="endpaper-first-thm-img"
                    :src="endpaperContent"
                  >
                </div>

                <v-col
                  v-for="(thumb, idx) in thumbImages"
                  :key="idx"
                  class="px-0"
                  :style="{ flex: props.pageSide === 1 ? 'unset' : (props.pageSide === 2 && !thumbImages[0].doublepage ? '0 0 50%' : 'unset') }"
                >
                  <!-- w-100 h-100  -->
                  <div
                    class="d-flex flex-column align-center justify-center"
                    style="height: 218px;"
                  >
                    <!-- 양/단면 변경 시 자동 스크롤 실행 시키기 위해 이미지 모두 리랜더링하도록 key값 부여 -->
                    <!-- :src값 : 새로고침 시 매번 새로운 이미지 데이터로 갱신될 수 있도록 하기 위함. -->
                    <v-img
                      :key="'pageSide-'+props.pageSide+'-idx-'+index+'['+idx+']'"
                      :src="thumbBlobSrc(thumb.src)"
                      width="100%"
                      height="100%"
                      class="cursor-pointer"
                      :eager="true"
                      @load="handleThumbImageLoad(thumb.src)"
                    >
                      <!-- v-progress-circular: 이미지 로드 중 -->
                      <template #placeholder>
                        <v-row
                          class="fill-height fill-width ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          />
                        </v-row>
                      </template>
                    </v-img>
                    <span
                      class="w-100 text-center cursor-pointer"
                      :class="{ 'selected-text': selectedGroupIndex == index }"
                    > {{ thumb.Name }} </span>
                  </div>
                </v-col>
                <!-- 양면인 경우 + 마지막 면인 경우 or 지역 지면인 경우 : 속지 -->
                <div
                  v-if="props.pageSide === 2
                    && !thumbImages[0]?.firstpage // 첫번째 면 + 지역 지면인 경우는 지면지면용 속지 필요 없음.
                    && ( thumbImages[0]?.lastpage|| thumbImages[0]?.localpage || thumbImages[0]?.isNextLocalpage )
                  "
                  class="cursor-pointer"
                  style="width: 138.5px; background-color: #E0E8F9;"
                >
                  <v-img
                    width="100%"
                    height="100%"
                    :src="thumbImages[0]?.lastpage ? require('../../assets/images/lastpg.png') : require('../../assets/images/replacepg.png')"
                  />
                </div>
              </li>
            </ul>
          </v-row>
        </v-card>
      </div>
    </v-card>

    <v-card
      v-show="props.tab=='option-2'"
      class="mx-auto"
      flat
    >
      <!-- 저장된 검색 키워드 목록 -->
      <div>
        <v-toolbar
          background-color="background"
          color="background"
          class="d-flex align-center cursor-pointer"
          style="padding: 8px 16px 8px 0px;"
          height="42"
          @click="if(!userkeywordGroupStore.isKeywordListOn){openSavedKeywordGroup = [];};
                  userkeywordGroupStore.isKeywordListOn = !userkeywordGroupStore.isKeywordListOn;"
        >
          <!-- 검색 키워드 목록 열고 닫기 버튼 -->
          <v-icon
            :icon="userkeywordGroupStore.isKeywordListOn ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            :class="userkeywordGroupStore.isKeywordListOn ? 'collapseKeywordListpOpen' : 'collapseKeywordListClose'"
            style="margin: 0px 4px 0px 4px;"
            :ripple="false"
          />

          <div class="text-subtitle-1 font-weight-bold">
            저장된 검색 키워드 목록
          </div>

          <v-spacer />

          <v-chip
            :ripple="false"
            class="me-0 group-setting"
            size="small"
            prepend-icon="mdi-folder-plus"
            value="그룹관리"
            variant="outlined"
            style="color: #3182f6;"
            @click.stop="userkeywordGroupStore.$keywordGroupClick();"
          >
            그룹관리
          </v-chip>
        </v-toolbar>

        <v-divider />

        <v-expand-transition>
          <div
            v-show="userkeywordGroupStore.isKeywordListOn"
            class="expandable-list"
          >
            <v-list
              v-if="(userkeywordGroupStore.keywordData && userkeywordGroupStore.keywordData.length != 0)"
              class="scroll-container5 noHeaderHeight"
              :opened="openSavedKeywordGroup"
              density="compact"
              nav
              lines="one"
              style="max-height: 200px; overflow: hidden auto;"
              :activatable="false"
            >
              <v-list-group
                v-for="(group, index) in userkeywordGroupStore.keywordData"
                :key="index"
                v-model="openSavedKeywordGroup"
                :value="group.groupSeq"
              >
                <template #activator="{ props }">
                  <!-- 그룹 -->
                  <v-list-item
                    class="ms-0 text-left"
                    v-bind="props"
                    :ripple="false"
                    style="min-height: 32px; font-size: 15px; padding: 4px 0px; text-align: left; margin-left: 0px;"
                    @click="setSavedKeywordGroupOpen(group.groupSeq);"
                  >
                    <div class="d-flex align-center">
                      <v-icon
                        size="small"
                        color="#DBDBDB"
                        style="margin-right: 5px;"
                      >
                        mdi-folder-open-outline
                      </v-icon>
                      <div class="bold-text keyword-text">
                        {{ group.groupName }}
                      </div>
                      <span class="grp-num">{{ group.keywords ? group.keywords.length : '0' }}</span>
                    </div>
                  </v-list-item>
                </template>

                <v-card
                  variant="flat"
                  class="pa-0 ma-0 w-100 h-100"
                >
                  <v-list
                    v-if="(group.keywords && group.keywords.length != 0)"
                    class="pa-0"
                    nav
                    base-color="transparent"
                  >
                    <v-list-item
                      v-for="(savedKeyword, i) in group.keywords"
                      :id="'savedKeyword-list-' + savedKeyword.kwSeq"
                      :key="i"
                      :ripple="false"
                      class="pa-0 ma-0"
                      style="min-height: 32px;"
                      @click="searchClickBySavedKeyword(savedKeyword.keyword);"
                    >
                      <div class="d-flex ms-4">
                        <!-- 점선 -->
                        <div :class="i !== group.keywords.length - 1 ? 'custom-border1' : 'custom-border2'" />

                        <!-- 아이콘과 검색 키워드 텍스트 -->
                        <v-icon
                          size="small"
                          color="#DBDBDB"
                          class="mt-1 ms-2"
                        >
                          mdi-note-text-outline
                        </v-icon>
                        <div class="d-flex align-center">
                          <div class="keyword-text one-keyword">
                            {{ savedKeyword.keyword }}
                          </div>
                        </div>

                        <!-- 키워드 삭제 버튼 -->
                        <div class="ml-auto me-1 d-flex align-center">
                          <v-btn
                            variant="flat"
                            size="small"
                            color="primary"
                            style="padding: 0px 8px; font-size: 12px; min-height: 24px;"
                            @click.stop="userkeywordGroupStore.$removeKeyword(group.groupSeq, savedKeyword.kwSeq);"
                          >
                            삭제
                          </v-btn>
                        </div>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-list-group>
            </v-list>
          </div>
        </v-expand-transition>
        <v-divider
          v-if="userkeywordGroupStore.isKeywordListOn"
          class="fade-divider"
        />
      </div>
      <div
        class="px-4 pt-4 pb-1"
        min-height="96"
      >
        <!-- v-menu : 검색창 클릭 시 검색기록을 드롭다운 메뉴로 표시 -->
        <v-menu
          v-model="searchHistorymenu"
          :close-on-content-click="true"
          transition="scale-transition"
          location="bottom"
          location-strategy="static"
          style="top: 380px;"
          :style="{left: !mobile ? '59px' : '75px'}"
          :width="!mobile ? userJS.nestedDrawerWidth.value : '85%'"
        >
          <!-- 검색창 클릭 시 v-menu창 열리도록 설정. -->
          <!-- 검색어 삭제 버튼 나오도록 -> clearable -->
          <template #activator="{ props }">
            <div class="d-flex align-start">
              <v-text-field
                v-bind="props"
                v-model="searchTerm"
                autofocus
                class="srch me-2"
                density="compact"
                single-line
                variant="outlined"
                :hide-details="searchHistorymenu ? true : false"
                :rules="searchRules"
                hint="입력한 모든 단어가 포함된 기사를 검색합니다."
                @keyup.enter="searchClick();"
                @focus=" userJS.changeFocusingState(true);"
                @blur="userJS.changeFocusingState();"
              >
                <!-- 검색 키워드 저장하기 버튼-->
                <template #append-inner>
                  <v-chip
                    :ripple="false"
                    size="small"
                    value="검색 키워드 저장"
                    variant="flat"
                    color="primary"
                    class="me-2"
                    @click.stop="userkeywordGroupStore.$keywordGroupClick(searchTerm);"
                  >
                    저장
                  </v-chip>
                </template>
              </v-text-field>

              <!-- 검색하기 버튼 -->
              <v-btn
                icon
                class="searchClickBtn rounded-circle"
                size="small"
                color="primary"
                elevation="0"
                @click="searchClick();"
              >
                <v-icon class="text-white">
                  mdi-magnify
                </v-icon>
              </v-btn>
            </div>
          </template>
          <!-- 검색 기록창 -->
          <!-- &gt;는 '>'를 의미함 -->
          <v-list
            v-if="searchHistory.length &gt; 0"
            density="compact"
          >
            <v-list-item
              v-for="(item, index) in searchHistory"
              :key="index"
              :ripple="false"
              style="padding:0;"
              @click="searchClick(item.term)"
            >
              <div class="d-flex align-center kwd_list">
                <span class="mdi mdi-magnify kwd_ico" />
                <div class="kwd_listbox">
                  <v-list-item-title class="me-auto keyword-history-text">
                    {{ item.term }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-1 me-1">
                    {{ item.date }}
                  </v-list-item-subtitle>
                </div>
                <v-list-item-action>
                  <v-icon
                    style="color: rgb(142, 142, 142);"
                    @click.stop="removeSearchHistory(index)"
                  >
                    mdi-window-close
                  </v-icon>
                </v-list-item-action>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
        <div
          v-if="loaded"
        >
          <p class="srch_total">
            총 <b>{{ searchResults.totalNum }}</b> 건
          </p>
        </div>
      </div>
      <v-list
        v-if="loaded"
        class="scroll-container3 searchResultListHeight srch_list"
        :class="userkeywordGroupStore.isKeywordListOn ? 'withKeywordList' : ''"
        style="overflow-y:scroll;"
      >
        <v-list-item v-if="(searchResults?.totalNum == 0)">
          <v-list-item-title class="text-center">
            검색 결과가 없습니다.
          </v-list-item-title>
        </v-list-item>
        <!-- 검색 결과 -->
        <v-list-item
          v-for="(article, index) in searchResults.articles"
          v-else-if="(searchResults?.totalNum != 0)"
          :id="'search-result-'+index"
          :key="index"
          :ripple="false"
          @click="userJS.moveElementPosition('scroll-container3', 'search-result-'+index)"
        >
          <v-card
            class="cursor-pointer"
            variant="text"
            :style="{background: selectedSearchSerial == article.serial ? '#E4E4E4' : ''}"
          >
            <div
              class="srch_card"
              @click="selectedSearchSerial = article.serial;
                      $emit('handle-list-click', article.serial, undefined, undefined);"
            >
              <div class="px-4 pt-4 pb-2">
                <p
                  class="pb-1 srch_tit"
                  v-html="surroundingTitle(article.title)"
                />
                <p class="srch_info">
                  {{ article.serial.substring(12, 15) }}면 •
                  검색어 <b>{{ article.wordCount }}</b>건
                </p>
              </div>
              <div class="px-4 pb-4">
                <p
                  style="white-space: normal; font-size: 13px; font-weight: 400; line-height: 20px;"
                  v-html="`${surroundingContent(article.content, 40)}`"
                />
              </div>
            </div>
          </v-card>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card
      v-show="props.tab=='option-3'"
      flat
    >
      <v-toolbar
        background-color="background"
        color="background"
        class="pa-2 d-flex align-center"
        height="42"
      >
        <div class="text-subtitle-1 font-weight-bold">
          북마크
        </div>

        <v-spacer />

        <v-chip-group
          v-if="bookmarkOptions.length"
          v-model="localScrapAlignment"
          class="nestedDrawerChipGroup"
          :class="{ 'single-option': bookmarkOptions.length === 1 }"
          selected-class="txt-co"
          mandatory
        >
          <v-chip
            v-for="opt in bookmarkOptions"
            :key="opt.key"
            :ripple="false"
            class="me-0"
            size="small"
            :value="opt.value"
            :prepend-icon="opt.icon"
            variant="outlined"
          >
            {{ opt.label }}
          </v-chip>
        </v-chip-group>
      </v-toolbar>

      <v-divider />
      <div
        v-if="(userEmailStore.localScrapData && userEmailStore.localScrapData.length == 0)"
        class="noHeaderHeight"
      >
        <p class="pa-2 text-center">
          등록한 북마크가 없습니다.
        </p>
      </div>
      <!-- v-model:opened="openScrapGroup" 가 eslint에 의해 사용안됨. 대신 setScrapGroupOpen(group.seq) 함수로 구현. -->
      <v-list
        v-if="(userEmailStore.localScrapData && userEmailStore.localScrapData.length != 0)"
        class="scroll-container4 noHeaderHeight"
        :opened="openScrapGroup"
        density="compact"
        nav
        lines="one"
        open-strategy="multiple"
        style="overflow-y:scroll;"
      >
        <v-list-group
          v-for="(group, index) in userEmailStore.localScrapData"
          :key="index"
          v-model="openScrapGroup"
          :value="group.seq"
        >
          <template #activator="{ props }">
            <!-- :id="'bookmark-group-'+index" -->
            <v-list-item
              class="articleList"
              v-bind="props"
              :ripple="false"
              @click="setScrapGroupOpen(group.seq);"
            >
              <div
                class="d-flex flex-ct bold-text"
                :class="localSelectedScrapGroupSeq == group.seq ? 'selected-news' : '' "
                @click="$emit('set-selected-scrap-group-seq', group.seq);"
              >
                {{ group.name + ' 그룹 ' }}<span class="grp-num">{{ group.list ? group.list.length : '0' }}</span>
              </div>
            </v-list-item>
          </template>
          <v-card variant="flat">
            <v-row class="ma-auto pa-2 w-100 d-flex flex-column align-items-center bmk_ul">
              <v-col
                v-for="(scrap, i) in group.list"
                :id="'bookmark-list-'+i"
                :key="i"
                class="px-0"
                @click="userJS.moveElementPosition('scroll-container4', 'bookmark-list-' + i)"
              >
                <div
                  class="w-100 h-100 d-flex flex-column align-center justify-center pa-4 bmk_li"
                  :style="{filter : localSelectedScrapSeq == scrap.scrapSeq ? 'brightness(0.9)' : ''}"
                  @click="$emit('handle-list-click', scrap.serial, undefined, scrap);"
                >
                  <!-- 북마크 이미지 -->
                  <v-img
                    :key="scrap.scrapSeq"
                    :src="bookmarkBlobSrc(userEmailStore.$returnBookmarkImage(scrap, props.mediaSeq))"
                    width="100%"
                    max-height="125"
                    class="cursor-pointer bookmark-img"
                    :eager="true"
                  >
                    <!-- v-progress-circular: 이미지 로드 중 -->
                    <template #placeholder>
                      <v-row
                        class="fill-height fill-width ma-0"
                        align="center"
                        justify="center"
                        style="min-height: 100px;"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        />
                      </v-row>
                    </template>
                  </v-img>

                  <!-- 북마크 삭제 버튼 -->
                  <div>
                    <button
                      type="button"
                      class="show-bookmark-remove-btn"
                      @click.stop="removeBookmark(scrap);"
                    >
                      <span class="mdi mdi-bookmark" />
                    </button>
                  </div>

                  <div class="w-100 bmk">
                    <p class="bmk_pg">
                      <span>{{ scrap.serial?.substring(12, 15) }}면</span>
                    </p>
                    <p class="bmk_tit">
                      {{ scrap.title }}
                    </p>
                    <p class="bmk_date">
                      <span>발행일 : {{ scrap.newsDate }}</span>
                      <span>북마크일 : {{ scrap.regDate }}</span>
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-list-group>
      </v-list>
    </v-card>
    <v-card
      v-show="props.tab=='option-4'"
      flat
    >
      <!-- <div
        class="mx-auto"
        style="width:50px; height: 50px; backgroud-color:black;"
      /> -->
      <MailSide
        :media-seq="props.mediaSeq"
        :tab="props.tab"
        :dragging="dragging"
      />
    </v-card>
    <!-- <v-card
      v-show="props.tab=='option-5'"
      flat
    >
      <div
        class="mx-auto"
        style="width:50px; height: 50px; backgroud-color:black;"
      />
    </v-card> -->
  </v-navigation-drawer>
</template>

<script setup>
import axios from "axios"
import { computed, ref, watch, nextTick, onMounted, onUpdated, reactive, onBeforeUnmount } from 'vue';
const { mobile, width } = useDisplay();
import { useDisplay } from 'vuetify'
import { useUserStore, useUserInfoStore, useUserAlertStore, useUserKeywordGroupStore, useUserEmailStore, useUserMobileStore } from '@/store';
const userStore = useUserStore();
const userInfoStore = useUserInfoStore();
const userAlertStore = useUserAlertStore();
const userkeywordGroupStore = useUserKeywordGroupStore();
const userEmailStore = useUserEmailStore();
const userMobileStore = useUserMobileStore();

import { userJS } from '@/assets/js/index';

import MailSide from '@/components/user/MailSide.vue';

const props = defineProps({
    vw:Number, nestedDrawer: Boolean, drawer5: Boolean, news: Array, tab: String, open:Array,
    scrapSerialList:Array, selectedScrapSeq:Number, selectedScrapGroupSeq:Number, pageSide:Number, thumbnailBind:Array, scrapAlignment:String,
    datepicker:Date, roleSelection: String, selectedArticleSerial:String, selectedArticleGroupSerial:String,
    mediaSeq:String, setArticleListOpenGroup:Function,
    showScrapList:Function, selectedPageIndex:Number,
  });
  const emit = defineEmits([
    'call-remove-scrap-a-p-i',
    'call-scrap-list-by-scrap-date','call-scrap-list-by-publication-date',
    'call-alert-visible-to-true','handle-list-click', 'call-show-article-detail-view', 'change-selected-scrap-seq',
    'call-move-news-paper','call-keyword-from-search-results','set-selected-scrap-group-seq', 'nested-drawer-to-false',
  ]);

  const localOpen = ref(props.open);
  const localNestedDrawer = ref(props.nestedDrawer);
  const localDrawer5 = ref(props.drawer5);
  const localNews1 = ref(props.news);
  const localScrapAlignment = ref(props.scrapAlignment);
  const localSelectedScrapSeq = ref(props.selectedScrapSeq);
  const localSelectedScrapGroupSeq = ref(props.selectedScrapGroupSeq);
  watch(() => props.open, (newVal) => {
    localOpen.value = newVal;
  });

  watch(() => props.drawer5, (newVal) => {
    localDrawer5.value = newVal;
  });

  let searchResults = ref({});// 검색 결과
  watch(() => props.news, (newVal) => {
    localNews1.value = newVal;

    autoScroller(0); // 선택된 기사 면도 함께 초기화.

    // 기사 찾기 탭
    if(props.tab == 'option-2') {
      searchResults.value = {};// showArticleList() 호출 시 검색 결과 초기화
      if(searchTerm.value != '') searchClick();
    }
  });
  watch(() => props.selectedScrapSeq, (newVal) => {
    localSelectedScrapSeq.value = newVal;
  });
  watch(() => props.selectedScrapGroupSeq, (newVal) => {
    localSelectedScrapGroupSeq.value = newVal;
  });

  // 리스트 - 항상 단면일 때 index 반환 from groupSerial
  function getSinglePageIndex(serial) {
    return localNews1.value.findIndex(each => each.Serial == serial);
  }

  // 기사 목록 - 지면 선택 상태 기능 =======[start]=============================
  const articleTitle = ref(null);
  watch(() => props.selectedArticleSerial, (serial) => {
    if(serial == '') {// 기사 상세보기 창 닫기 버튼 클릭했을 때 or 새로운 날짜 클릭 시 면 클릭 상태는 초기화함.
      selectedGroupIndex.value = -1;
      return;
    } else {
      // 단면인 경우
      if(props.pageSide == 1) {
        selectedGroupIndex.value = props.selectedPageIndex;
        return;
      }

      // 양면인 경우
      if (articleListSelection.value === 'LIST_VIEW') {
        selectedGroupIndex.value = getSinglePageIndex(props.selectedArticleGroupSerial);
      } else {
        // THUMBNAIL_VIEW
        selectedGroupIndex.value = props.selectedPageIndex;
      }
    }


    // 북마크 기능 관련.
    // 북마크들의 기사 serial을 담은 배열(props.scrapSerialList)과 비교해서
    // 클릭한 기사(at 기사목록 or 지면 이미지)의 serial이 없다면 북마크 선택 상태 해제.
    if (!props.scrapSerialList.includes(serial)) emit('change-selected-scrap-seq', -1);
    // 북마크 리스트 열린 상태 -> 지면 이미지 위에서 기사 클릭 시 -> 닫히도록(+)
    if(props.tab == 'option-3' && localNestedDrawer.value) emit('nested-drawer-to-false');
  });
  // =====================================[end]================================

  // 속지 ================================[start]==============================
  let endpaperContent = window.location.hostname === 'localhost' ? require('../../assets/images/npaperLogo.png') : userInfoStore.logo;
  // =====================================[end]================================

  // 썸네일 이미지를 axios 호출 통해 blob으로 받아오기 =[start]======================
  // -> axios.interceptor.request를 거쳐서 요청 header에 Pmaster-Sid 값을 포함시켜주기 위함.
  // 썸네일 ObjectURL 캐시와 중복 요청 방지 세트
  const thumbBlobMap = reactive({});     // { [baseUrl]: objectUrl }
  const inflightThumbSet = new Set();    // 중복 axios 방지 (baseUrl 기준)

  // axios(interceptor 적용)로 이미지 → blob 받아 ObjectURL로 반환
  function thumbBlobSrc(baseUrl) {
    // 이미 만들어 둔 ObjectURL 있으면 즉시 반환
    if (thumbBlobMap[baseUrl]) return thumbBlobMap[baseUrl];

    // 진행 중이 아니면 요청 시작
    if (!inflightThumbSet.has(baseUrl)) {
      inflightThumbSet.add(baseUrl);

      // 캐시 무력화: _=timestamp 파라미터 추가
      const bust = (baseUrl.includes('?') ? '&' : '?') + '_=' + Date.now();
      const requestUrl = baseUrl + bust;

      axios.get(requestUrl, {
        responseType: 'blob',
        withCredentials: true,  // 쿠키/세션 필요 시
      })
      .then(({ data }) => {
        // 기존 ObjectURL이 있다면 정리 후 교체
        if (thumbBlobMap[baseUrl]) {
          try { URL.revokeObjectURL(thumbBlobMap[baseUrl]); } catch {}
        }
        // blob → ObjectURL 생성 후 캐시에 저장 (반응형으로 v-img 갱신)
        thumbBlobMap[baseUrl] = URL.createObjectURL(data);
      })
      .catch((e) => {
        console.error('thumb load failed:', e);
      })
      .finally(() => {
        inflightThumbSet.delete(baseUrl);
      });
    }

    // 로딩 전에는 빈 값 반환(렌더는 되지만 이미지 없이 나타남)
    return '';
  }

  // 메모리 정리: 컴포넌트 파괴 시 ObjectURL 해제
  onBeforeUnmount(() => {
    Object.values(thumbBlobMap).forEach((objUrl) => {
      try { URL.revokeObjectURL(objUrl); } catch {}
    });
  });
  // =====================================[end]================================

  // 자동 스크롤 ==========================[start]==============================
  let isThumbClicked = false;// 썸네일 이미지 클릭 여부 -> handleListGroupClick()에서 변경.

  async function autoScroller(groupSerial) {//자동 스크롤 기능 함수
    if(!localNestedDrawer.value) return;//스크롤 영역이 열려있을 때만 실행하도록
    await nextTick();//리스트가 모두 렌더링 된 후 실행하도록

    let i = -1;
    if (articleListSelection.value === 'THUMBNAIL_VIEW') {
      if(groupSerial == 0) {
        i = 0;
        if(selectedGroupIndex.value != -1) selectedGroupIndex.value = -1;
      } else {
        i = props.selectedPageIndex;
        selectedGroupIndex.value = i;
      }
      userJS.moveElementPosition('scroll-container2', 'thumbnail-list-'+i);

      if(isThumbClicked && mobile.value) {
        emit('nested-drawer-to-false');//모바일에서 썸네일 클릭 시 기사목록 창 닫히도록.
        isThumbClicked = false;
      }
    } else { // LIST_VIEW
      if(groupSerial == 0) {
        i = 0;
        if(selectedGroupIndex.value != -1) selectedGroupIndex.value = -1;
      } else {
        i = getSinglePageIndex(groupSerial);
        selectedGroupIndex.value = i;
      }
      userJS.moveElementPosition('scroll-container1', 'group-'+i);
    }
  }

  // 1. pre/next 버튼 클릭 시 & handleListGroupClick() & handleListClick() 실행 시 ===
  watch(()=>props.selectedArticleGroupSerial, (groupSerial)=>{
    if(groupSerial != '') autoScroller(groupSerial); // 기사 상세보기 창 닫기 버튼 클릭했을 때 스크롤 이동 없음.
  });
  // 2. 지면 데이터 변경 시 - 날짜 변경 시 / 매체 변경 시 ========================
  // -> props.news를 watch로 감시하는 부분

  // 3. 썸네일 -> 리스트 변경 시 ================================================
  const articleListSelection = ref('LIST_VIEW');
  watch(articleListSelection, (newVal, oldVal)=>{
    if (oldVal === 'THUMBNAIL_VIEW' && newVal === 'LIST_VIEW') {
      const serial = props.selectedArticleGroupSerial;
      if (!serial || serial=="") return;
      autoScroller(serial);
    }
    if(selectedGroupIndex.value == -1) {// 초기에 아무 기사도 선택하지 않고 기사 목록 스크롤만 내리다가 articleListSelection 변경하면 다시 스크롤 맨 위로 올라오도록.
      autoScroller(0);
      return;
    }
  });

  // 4. '기사 찾기' tab (선택 기사 변경 후) -> 기사목록 tab 클릭 시 ==============
  watch(()=>props.tab, (newVal, oldVal)=>{
    searchHistorymenu.value = false;// 검색창 - 검색 기록창 켜져있는 상태에서 resize error 피하기 위함.

    // 모바일에서 '기사 찾기(option-2)' 탭에 들어올 때
    // 저장된 검색 키워드 목록을 기본으로 접어두기
    if (mobile.value && newVal === 'option-2') {
      userkeywordGroupStore.isKeywordListOn = false;  // 목록 접기
      openSavedKeywordGroup.value = [];               // 열려있던 그룹도 모두 닫기
    }

    const serial = props.selectedArticleGroupSerial;
    if(oldVal !== 'option-1' && newVal == 'option-1' && serial != -1){
      autoScroller(serial);
    }
  });

  // 5. 썸네일 이미지 로딩 시 ===================================================
  // 1) 기사 목록-리스트 -> 기사목록-썸네일로 변경 시
  // 2) 기사목록-썸네일인 경우
  //    2-1) 단면 -> 양면
  //    2-2) 양면 -> 단면
  //    2-3) nestedDrawer.vue가 열릴 때마다
  const thumbLoadingSuccess = ref(false);
  let thumbImagesLoaded = 0;
  const resetThumbImagesLoaded = () => {
    if(thumbImagesLoaded != 0)thumbImagesLoaded = 0;
  };
  onUpdated(() => {
    resetThumbImagesLoaded();
  });
  const handleThumbImageLoad = (a) => {// img 태그에 걸려있는 로드 됐을 때의 실행 함수.
    if(thumbImagesLoaded) thumbLoadingSuccess.value = false;
    thumbImagesLoaded++;
    if(thumbImagesLoaded == localNews1.value.length) {
      thumbLoadingSuccess.value = true;
      resetThumbImagesLoaded();
    }
  };
  let serialBeforeScroll = '';
  watch(thumbLoadingSuccess, (newValue, oldValue)=>{// 썸네일 이미지 로딩 완료 후 자동 스크롤 되도록.
    if(oldValue && !newValue) return;
    if(!oldValue && newValue){
      const serial = props.selectedArticleGroupSerial;
      if (serial == serialBeforeScroll || !serial || serial=="") return;
      serialBeforeScroll = serial; // 선택한 지면 -> 다시 선택하기 전에는 썸네일 이미지 재로딩 완료 이후에도 자동 스크롤 안 되도록!
      autoScroller(serial);
    }
  })

  watch(() => props.nestedDrawer, (newVal) => {
    localNestedDrawer.value = newVal;

    if(newVal && props.selectedArticleGroupSerial != ''){
      autoScroller(props.selectedArticleGroupSerial);
    }
    // 열고 닫힐 때마다 북마크 선택 상태 해제
    if(localSelectedScrapSeq.value != -1) emit('change-selected-scrap-seq', -1);
  });

  // =========================================[end]============================

  // 기사 목록 - 지면 선택 상태 변경 시 ========[start]==========================

  const selectedGroupIndex = ref(-1);
  function handleListGroupClick(index, serial=null){
    resetThumbImagesLoaded();//렌더링 끝나기도 전에 이미지 클릭 시
    const list = props.thumbnailBind;
    // 썸네일 클릭 시 index만 보냄.
    const isThumbnail = !serial ? true : false;
    // 1) '썸네일'에서 클릭했을 때 -> index로 serial 구하기.
    if(isThumbnail){
      serial = list[index][0].Serial;
      isThumbClicked = true;
    } else isThumbClicked = false;// 2) '리스트'에서 클릭했을 때. serial 그대로 넘겨주기.
    emit('call-move-news-paper', serial);

    // 20250923 최지현 - 별지 포함 링크에 의해 바로 별지 선택하여 해당 페이지로 이동 후,
    // 별지 정보는 삭제되도록.
    if(userStore.localpageSerial !== '') {
      userStore.localpageSerial = '';
      //console.log("별지 페이지 초기화!");
    }
  };

  // =========================================[end]============================


  // 검색 기능 구현 ===========================[start]==========================
  const searchRules = [                                                // 사용 시 :rules = "searchRules" 속성 추가(+)
    v => !!v || '값을 입력해주세요.',                                   // 빈 문자열 체크
    v => v && v.length >= 2 || '특수문자 외 두 글자 이상 입력해주세요.', // 최소 길이 설정
  ]
  let searchHistorymenu = ref(false);                                 // 검색어 클릭 시 이전 검색 기록 보이기 여부
  async function searchAPI(word) {
    let params = new URLSearchParams();
    params.append('keyword', word);
    params.append('date', props.datepicker.format('yyyyMMdd'));
    params.append('mediaSeq', props.mediaSeq);
    return await userJS._api.getSearchResult(params);
  };

  const searchTerm = ref('');// 검색어

  // 검색 결과 배열 -> searchResults.value
  // 검색 결과 호출 API 반환 함수
  async function showSearchResult(word){
    try {
      userJS.searchResultSerialArr.value = [];
      const res = await searchAPI(word);
      if(res.success != undefined && (res.message || res.msg)){
        if(!res.success){
          alert(res.message || res.msg);
          searchResults.value.totalNum = 0;
          emit('call-keyword-from-search-results', []);
          return;
        } else if (res.success && res.result == []) {
          searchResults.value.totalNum = 0;
          emit('call-keyword-from-search-results', []);
          return;
        }
      } else {
        if(res && res != '' && res.ArticleMap != undefined){
          const articles = res.ArticleMap;
          let obj = {
            articles: articles.map(article => {
              userJS.searchResultSerialArr.value.push(article.articleSerial);
              return {
                serial: article.articleSerial,
                title: article.title,
                titleSub: article.titleSub,
                coordinate: article.coordinate,
                wordCount: article.wordCount,       // 기사 당 검색 키워드가 등장한 횟수.
                updateTime: article.updateTime,     // 해당 기사 발행일
                content: article.content,
              }
            }),
            keyword: res.processInfo.Keywords,      // 배열임. AND 검색의 경우 검색어 요소 여러개일 수 있음.
            reqTime: res.processInfo.reqTime,       // 검색일시 형식 예시) 20240611173440
            totalNum: res.TotalNum,                 // 검색된 총 기사 갯수
          }
          searchResults.value = obj;
          emit('call-keyword-from-search-results', searchResults.value.keyword);
          if(localDrawer5.value) emit('call-show-article-detail-view', props.selectedArticleSerial); // 이미 기사 상세보기 창이 열린 채 기사 검색 했을 , 바로 기사 상세보기 창 기사 이미지에 키워드 하이라이트 되도록.
        } else {
          searchResults.value.totalNum = 0;
          emit('call-keyword-from-search-results', []);
        }
      }
      // 검색을 완료하면 이전 검색 기록 메뉴를 닫음
      searchHistorymenu.value = false;
      // 검색 결과 검색 기록이 없는 경우 -> 기존 키워드 하이라이트 영역이 있다면 제거
      if(!searchResults.value.totalNum) userJS.noResult.value = true;
      else userJS.noResult.value = false;
    } catch (error) {
      throw error;
    }
  }

  // 검색 결과 커스텀 : 기사 제목이 검색어를 포함하는 경우 - 검색어 하이라이트 기능
  function surroundingTitle(title){
    const searchTerms = searchResults.value.keyword;
    let highlightedHTML = title;

    searchTerms.forEach(term => {
      const regex = new RegExp(term, 'gi');                    // 대소문자 구분 없이 모든 키워드를 찾기 위해 정규 표현식 사용
      highlightedHTML = highlightedHTML.replace(regex, match => `<span class="srch_mark">${match}</span>`);
    });
    return highlightedHTML;
  }

  function surroundingContent(content, numberOfChar) {
    const searchTerms = searchResults.value.keyword; // 검색 키워드 배열
    let earliestMatchIndex = content.length; // 가장 앞에 있는 매칭 시작 인덱스 초기값
    let earliestMatchRange = null; // 가장 앞 매칭된 키워드의 범위

    // 공백과 줄바꿈을 무시하고 키워드 매칭을 찾는 함수
    function findKeywordRanges(text, keyword) {
      const keywordLength = keyword.length;
      let ranges = [];
      let cleanIndex = 0; // 키워드에서 비교할 인덱스
      let matchStart = -1; // 매칭 시작 인덱스

      for (let i = 0; i < text.length; i++) {
        if (text[i] === " " || text[i] === "\n") continue; // 공백, 줄바꿈 무시

        if (text[i] === keyword[cleanIndex]) {
          if (cleanIndex === 0) matchStart = i; // 첫 매칭 시작 위치 기록
          cleanIndex++;

          if (cleanIndex === keywordLength) {
            ranges.push([matchStart, i + 1]); // 매칭 범위 저장
            if (matchStart < earliestMatchIndex) {
              earliestMatchIndex = matchStart; // 가장 앞 매칭 업데이트
              earliestMatchRange = [matchStart, i + 1];
            }
            cleanIndex = 0; // 초기화
          }
        } else {
          cleanIndex = 0; // 매칭 실패 시 초기화
        }
      }
      return ranges;
    }

    // 모든 키워드의 매칭 범위 확인
    const allRanges = [];
    searchTerms.forEach(term => {
      const ranges = findKeywordRanges(content, term);
      allRanges.push(...ranges); // 모든 범위 저장
    });

    // 가장 앞 매칭된 단어 기준으로 앞뒤로 자르기
    if (earliestMatchRange) {
      const [startIndex, endIndex] = earliestMatchRange;

      // 앞뒤로 numberOfChar만큼 자르기
      const startSlice = Math.max(0, startIndex - numberOfChar);
      const endSlice = endIndex + numberOfChar*2;
      const visibleContent = content.substring(startSlice, endSlice > 1 ? endSlice : content.length);

      // visibleContent 내에서 모든 키워드를 하이라이팅 처리
      const keywordRanges = []; // 하이라이팅 범위 저장
      searchTerms.forEach(term => {
        const keywordChars = term.replace(/\s+/g, ""); // 키워드에서 공백 제거
        const ranges = findKeywordRanges(visibleContent, keywordChars);
        keywordRanges.push(...ranges); // visibleContent 범위에 맞게 추가
      });

      // 하이라이팅 처리: 뒤에서 앞으로 처리하여 인덱스 문제 방지
      let highlightedHTML = visibleContent;
      keywordRanges
        .sort((a, b) => b[0] - a[0]) // 역순 정렬
        .forEach(([rangeStart, rangeEnd]) => {
          const before = highlightedHTML.substring(0, rangeStart);
          const matched = highlightedHTML.substring(rangeStart, rangeEnd);
          const after = highlightedHTML.substring(rangeEnd);

          highlightedHTML = `${before}<span class="srch_mark">${matched}</span>${after}`;
        });

      return highlightedHTML;
    } else {
      // 키워드가 없으면 처음 numberOfChar * 2 만큼 반환
      return content.substring(0, numberOfChar * 2);
    }
  }



  const loaded = ref(false);                                   // 검색 결과 로딩 완료 여부
  const loading = ref(false);                                  // 로딩 상태
  const searchHistory = ref(userInfoStore.searchHistory);      // 이전 검색 기록

  // 검색 기능 함수
  function searchClick(termAtHistory) {
    if (termAtHistory) searchTerm.value = termAtHistory;//검색 기록창에서 클릭했을 때

    // 검색어에서 한글, 영어, 숫자만 남기고 다른 문자는 모두 제거한 후 2글자 미만일 때 예외처리.
    const cleanTerm = searchTerm.value.replace(/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9\s]/g, '');
    if (cleanTerm.trim().length < 2) {

      return;
    }

    // 로딩 시작
    loading.value = true;
    setTimeout(() => {
      searchHistorymenu.value = false;                       // 검색을 완료하면 검색 기록 메뉴를 닫음
      searchResults.value = {};                              // 검색 결과를 담을 배열 초기화

      let searchTermLower = searchTerm.value.toLowerCase();  // 검색어를 소문자로 변환
      showSearchResult(searchTermLower);

      loading.value = false;
      loaded.value = true; // 로딩

      // 검색 기록 저장 기능
      const term = searchTerm.value;
      if(term && term.length >=2) {                                                           // 검색어 2개 이상일 때만 저장되도록.
        const existingIndex = searchHistory.value.findIndex(item => item.term === term);      // 이전 검색 기록에 검색어가 없다면 -1을 반환.
        if (existingIndex !== -1) {                                                           // 입력한 검색어와 같은 이전 검색 기록이 있다면 기존 검색 기록 삭제.
          searchHistory.value.splice(existingIndex, 1);
        }
        searchHistory.value.unshift({ term: term, date: new Date().format('yyyy-MM-dd') });   // 검색어를 최신으로 추가
        if (searchHistory.value.length >= 6) {// 10개까지만 저장. 개수 넘어가면 맨 마지막 검색 기록은 지우도록.
          searchHistory.value.splice(-1, 1);
        }
      }
    }, 500);
  }

  // 클릭-선택한 검색 결과 - serial
  const selectedSearchSerial = ref('');

  // 검색 기록 삭제 버튼 기능
  function removeSearchHistory(index) {
    searchHistory.value.splice(index, 1);
  }
  // =========================================[end]============================

  // 검색 키워드 저장 기능 ====================[start]==========================

  const selectedKeywordIdx = ref(''); // 선택된 저장된 키워드 css

  // let openSavedKeywordGroup = computed(()=>{ // 배열에 담긴 요소 -> 열린 그룹 의미
  //   let arr = [];
  //   if(!userkeywordGroupStore.keywordData) return arr;
  //   userkeywordGroupStore.keywordData.forEach((g, i)=>{
  //     arr.push(i);
  //   })
  //   return arr;
  // });
  const openSavedKeywordGroup = ref([]);// 배열에 담긴 요소 -> 열린 그룹 의미

  function setSavedKeywordGroupOpen(groupSeq) {// 그룹 제목 클릭하면 toggle 기능
    const groupIndex = openSavedKeywordGroup.value.indexOf(groupSeq);
    if (groupIndex !== -1) {
      openSavedKeywordGroup.value.splice(groupIndex, 1);
    } else {
      openSavedKeywordGroup.value.push(groupSeq);
    }
  };

  function searchClickBySavedKeyword(savedKeyword){// 검색
    searchTerm.value = savedKeyword;
    if(searchTerm.value && searchTerm.value == savedKeyword) {
      document.querySelector('.searchClickBtn').click();
    }
  }

  // =========================================[end]===========================

  // 북마크 ===========================[start]=================================
  let openScrapGroup = computed(()=>{
    let arr = [];
    userEmailStore.localScrapData.forEach(g=>{
      arr.push(g.seq);
    })
    return arr;
  });
  function setScrapGroupOpen(groupSeq) {
    // 페이지가 배열에 있는지 확인
    const pageIndex = openScrapGroup.value.indexOf(groupSeq);
    // 페이지가 배열에 있을 때
    if (pageIndex !== -1) {
      // 해당 페이지를 배열에서 제거
      openScrapGroup.value.splice(pageIndex, 1);
    } else {
      // 기사 목록 열린 상태 여부 결정하는 배열.
      openScrapGroup.value.push(groupSeq);
    }
  };

  function removeBookmark(scrap){
    userAlertStore.$resetAllAlert();// 북마크 alert 창 켜져있다면 겹치지 않도록.
    emit('call-remove-scrap-a-p-i', scrap);
  }

  // 북마크 이미지 캐시 & 중복요청 방지
  const bookmarkBlobMap = reactive({});   // { [stableKey]: objectUrl }
  const inflightBookmarkSet = new Set();  // 진행 중 요청 집합( stableKey 기준 )

  // baseUrl에 기존에 붙어 있을 수 있는 '?_=123...' 를 키 비교에서만 제외
  function stripBustParam(rawUrl) {
    try {
      const u = new URL(rawUrl, window.location.origin);
      u.searchParams.delete('_');           // cache-buster 제거
      const qs = u.searchParams.toString();
      return `${u.origin}${u.pathname}${qs ? `?${qs}` : ''}`;
    } catch {
      // URL 파싱 실패 시, 가장 단순하게 '?_=' 패턴만 제거
      return rawUrl.replace(/([?&])_=\d+(&|$)/, (m, p1, p2) => (p2 ? p1 : ''));
    }
  }

  function bookmarkBlobSrc(baseUrl) {
    if(!userInfoStore?.PMASTER_SID || userInfoStore?.PMASTER_SID == ""){
      return '';
    }
    // 1) 키는 bust 제외한 안정 키로만 관리
    const stableKey = stripBustParam(baseUrl);

    // 2) 이미 캐시돼 있으면 즉시 반환
    if (bookmarkBlobMap[stableKey]) return bookmarkBlobMap[stableKey];

    // 3) 진행 중이 아니면 요청 시작 (요청 URL에는 그대로 bust 추가)
    if (!inflightBookmarkSet.has(stableKey)) {
      inflightBookmarkSet.add(stableKey);

      const bust = (baseUrl.includes('?') ? '&' : '?') + '_=' + Date.now();
      const requestUrl = baseUrl + bust;

      axios.get(requestUrl, {
        responseType: 'blob',
        withCredentials: true,
      })
      .then(({ data }) => {
        // 기존 ObjectURL 정리 후 교체
        if (bookmarkBlobMap[stableKey]) {
          try { URL.revokeObjectURL(bookmarkBlobMap[stableKey]); } catch {}
        }
        bookmarkBlobMap[stableKey] = URL.createObjectURL(data);
      })
      .catch((e) => {
        console.error('bookmark load failed:', e);
      })
      .finally(() => {
        inflightBookmarkSet.delete(stableKey);
      });
    }

    // 4) 로딩 전이면 빈 문자열 반환 → v-img는 src 변화만 반응
    return '';
  }

  // 언마운트 시 ObjectURL 정리(메모리 누수 방지)
  onBeforeUnmount(() => {
    Object.values(bookmarkBlobMap).forEach((objUrl) => {
      try { URL.revokeObjectURL(objUrl); } catch {}
    });
  });

  // =========================================[end]============================

  // 마우스 드래그로 너비 조정 기능 구현 ========[start]==========================
  // 좌측헤더 폈을 때의 너비
  let maxWidth = width.value - 510; // 기사 상세보기 창의 최소너비 450, 좌측 메뉴 1depth 너비 60
  let minWidth = 300;

  // 초기 상세보기 창 너비(px) : 실제 너비의 50%를 차지하도록 초기 설정하되 450보다 작으면 450
  function startDragging(e) {
    if (e.target.id === 'dragbarForMenu' || e.target.id === 'dragbarForMenu-icon') {
      searchHistorymenu.value = false; // 검색창 - 검색 기록창 켜져있는 상태에서 너비 조절 시 resize error가 발생하기 때문임.
      e.preventDefault();
      dragging = true;
      document.addEventListener('mousemove', moveArticleDetailView);
      document.addEventListener('mouseup', stopDragging);
    }
    document.body.style.cursor = 'col-resize'; // 드래그 상태에서 마우스 커서를 항상 col-resize로 변경
  }

  let dragging = false;
  let prevWidth = 0;
  function moveArticleDetailView(e) {
    if (dragging) {  // dragging = true -> 클릭한 상태
      let mw = e.pageX - 60; // dragging = true -> 클릭한 상태
      if ( maxWidth <= mw ) {
        userJS.nestedDrawerWidth.value = maxWidth;
      } else if ( minWidth >= mw ) {
        userJS.nestedDrawerWidth.value = minWidth;
      } else {
        userJS.nestedDrawerWidth.value = mw;
        let overlapCondition = userJS.isDrawerOverlap.value && userJS.nestedDrawerWidth.value > prevWidth;
        if(overlapCondition) {// 두 drawer가 overlap 되는 경우 우측 기사 상세보기 창 너비도 조절
          if (width.value - e.pageX <= 500) {// 임의의 값 500 -> 좌측 메뉴 너비 최대로 늘릴 때 e.pageX 위치에 의해 우측 기사 상세보기 창이 완전한 최소 너비(300)가 안 되는 문제해결.
            userJS.nestedDrawerWidth.value = maxWidth;
            userJS.articleDetailViewWidth.value = 450;
          } else {
            userJS.articleDetailViewWidth.value = width.value - userJS.nestedDrawerWidth.value - 60;
          }
        }
      }
      prevWidth = userJS.nestedDrawerWidth.value;
    }
  }

  function stopDragging(e) {
    if (dragging) {
      dragging = false;
      document.removeEventListener('mousemove', moveArticleDetailView);
      document.removeEventListener('mouseup', stopDragging);

      document.body.style.cursor = 'auto';                               // 드래그가 끝나면 기본 커서로 변경
    }
  }

  // =========================================[end]============================

  // === 북마크 탭 정렬 옵션: leftSidebar.bookmarkList ==========[start]==========
  // leftSidebar.bookmarkList.firstView / options 값 → 실제 버튼/기능 매핑
  const BOOKMARK_OPTION_DEFS = {
    DATE_ORDER: {
      // v-chip-group의 실제 value (부모 컴포넌트(HeaderPage.vue)에서 전달하는 값 유지: scrapDate)
      chipValue: 'scrapDate',
      // 라벨
      label: '북마크순',
      // 아이콘
      icon: 'mdi-bookmark-multiple-outline',
    },
    PUBLISH_ORDER: {
      chipValue: 'publicationDate',
      label: '발행순',
      icon: 'mdi-calendar-month-outline',
    },
  };

  // leftSidebar.bookmarkList 전체 설정 객체
  const bookmarkLayout = computed(() => {
    const layout = userMobileStore.$getMobileLayout(
      mobile.value,
      'leftSidebar',
      'bookmarkList',
    );
    return layout || {};
  });

  // bookmarkList.options 배열을 기반으로 실제 칩 목록 구성
  const bookmarkOptions = computed(() => {
    const optCodes = Array.isArray(bookmarkLayout.value.options)
      ? bookmarkLayout.value.options
      : [];

    return optCodes
      .map(code => {
        const def = BOOKMARK_OPTION_DEFS[code];
        if (!def) return null;

        return {
          key: code,              // 설정 코드 (DATE_ORDER / PUBLISH_ORDER)
          value: def.chipValue,   // v-chip :value → scrapDate / publicationDate
          label: def.label,       // 칩 라벨
          icon: def.icon,         // 칩 아이콘
        };
      })
      .filter(Boolean);
  });

  // bookmarkList.firstView / options 에 따라 초기 선택값 세팅 + 유효성 보정
  let bookmarkSelectionInitialized = false;
  watch(
    bookmarkLayout,
    (layout) => {
      const opts = bookmarkOptions.value;
      const firstViewIndex = opts.findIndex(opt => opt.key == layout.firstView);

      let initial = opts.length
        ? firstViewIndex !== -1 ? opts[firstViewIndex].value : opts[0].value
        : BOOKMARK_OPTION_DEFS[layout.firstView]?.chipValue; // options가 비어있으면 firstView를 initial로 사용

      if (!bookmarkSelectionInitialized) {
        // 최초 한 번만 초기값 세팅
        bookmarkSelectionInitialized = true;
        localScrapAlignment.value = initial;
        let emitFunc = initial == "scrapDate" ? 'call-scrap-list-by-scrap-date' : 'call-scrap-list-by-publication-date';
        emit(emitFunc, initial);
      }
    },
    { immediate: true },
  );


  // 북마크 정렬 기준이 바뀔 때마다 실제 정렬 API 호출
  watch(
    () => localScrapAlignment.value,
    (val) => {
      if (val === 'scrapDate') {
        // emit 이름은 defineEmits 쪽에 맞춰서 사용
        emit('call-scrap-list-by-scrap-date', 'scrapDate');
      } else if (val === 'publicationDate') {
        emit('call-scrap-list-by-publication-date', 'publicationDate');
      }
    },
  );

  // 좌측 사이드바 - 기사목록 뷰 전환 버튼 (리스트 / 썸네일) ========[start]==========
  // option 코드 → label, icon 매핑
  const ARTICLE_LIST_OPTION_DEFS = {
    LIST_VIEW: {
      label: '리스트',
      icon: 'mdi-list-box-outline',
    },
    THUMBNAIL_VIEW: {
      label: '썸네일',
      icon: 'mdi-view-grid-outline',
    },
  };

  // options 배열 순서대로 버튼 구성
  const articleListOptions = computed(() => {
    const opts = Array.isArray(articleListLayout.value.options)
      ? articleListLayout.value.options
      : [];

    return opts
      .map(key => {
        const base = ARTICLE_LIST_OPTION_DEFS[key];
        if (!base) return null;
        return {
          key,
          label: base.label,
          icon: base.icon,
        };
      })
      .filter(Boolean);
  });

  // userMobileStore.$getMobileLayout(mobile.value, 'leftSidebar', 'articleList') 사용
  const articleListLayout = computed(() => {
    // 모바일 여부에 따라 store helper 사용
    const layout = userMobileStore.$getMobileLayout(
      mobile.value,
      'leftSidebar',
      'articleList',
    );
    return layout || {};
  });

  // firstView 값으로 초기 한 번만 세팅
  let articleListSelectionInitialized = false;
  watch(
    articleListLayout,
    (layout) => {
      if (articleListSelectionInitialized) return;

      const opts = Array.isArray(layout?.options) ? layout.options : [];

      let initialView;

      if (opts.length === 1) {
        // options에 하나만 있을 때: 그 값을 우선 사용
        initialView = opts[0];
      } else {
        // 그 외: firstView → 없으면 options[0] → 그래도 없으면 LIST_VIEW
        initialView = layout?.firstView || opts[0] || 'LIST_VIEW';
      }

      articleListSelection.value = initialView;
      articleListSelectionInitialized = true;
    },
    { immediate: true },
  );
  // =========================================[end]============================

  // PC → 모바일로 전환될 때, 현재 기사목록 뷰/북마크 뷰가 모바일 옵션에 없으면 보정
  watch(
    () => mobile.value,
    (newVal, oldVal) => {
      // false → true 로 변할 때만 실행
      if (oldVal === false && newVal) {
        // === 기사목록(articleList) 보정 =======================================
        const layout = articleListLayout.value || {};
        const opts = Array.isArray(layout.options) ? layout.options : [];

        // 현재 보고 있던 기사목록 화면이 options 안에 없으면 처리
        if (!opts.includes(articleListSelection.value)) {
          if (!opts.length) {
            // 1) options가 아예 비었을 때 → firstView로 보여주기
            const fallback = layout.firstView || 'LIST_VIEW';
            articleListSelection.value = fallback;
          } else {
            // 2) options에 다른 옵션값들이 있을 때 → 그 중 첫 번째 값으로
            articleListSelection.value = opts[0];
          }
        }

        // === 북마크(bookmarkList) 보정 =======================================
        // bookmarkLayout.options → 코드 배열(DATE_ORDER / PUBLISH_ORDER)
        // bookmarkOptions → 실제 칩 정보 배열({ key, value(scrapDate...), label, icon })
        const bLayout = bookmarkLayout.value || {};
        const bOpts = bookmarkOptions.value || [];

        // 모바일에서 허용되는 chip value 목록 (['scrapDate', 'publicationDate', ...])
        const allowedBookmarkValues = bOpts.map(opt => opt.value);

        if (allowedBookmarkValues.length) {
          // 현재 보고 있는 정렬 기준이 모바일 옵션에 없으면 첫 번째 허용 값으로 보정
          if (!allowedBookmarkValues.includes(localScrapAlignment.value)) {
            localScrapAlignment.value = allowedBookmarkValues[0];
          }
        } else if (bLayout.firstView) {
          // options가 빈 경우 → firstView 코드로부터 chipValue를 찾아서 설정
          const def = BOOKMARK_OPTION_DEFS[bLayout.firstView];
          if (def?.chipValue) {
            localScrapAlignment.value = def.chipValue;
          }
        }
      }
    },
  );

  function setDesignClass(){
    const chipGroupContainer = document.querySelectorAll('.nestedDrawerChipGroup > .v-slide-group__container');
    if (chipGroupContainer) {
      chipGroupContainer.forEach(group => {// 각각 기사목록, 북마크 chip-group
        group.classList.add('tab');
      })
    }
  }
  onMounted(() => {
    setDesignClass();
    window.addEventListener('resize', function(){// 브라우저 자체 resize 시 or 기사 상세보기 창 resize 시
      maxWidth = width.value - 510;// 현재 브라우저 창을 기준으로 갱신
      userJS.resetLeft(minWidth, maxWidth, props.vw);
    }, false);
  })
</script>

<style scoped>

/* 디자인 후속작업 적용 */
.srch ::v-deep .v-field__overlay, .srch ::v-deep .v-field__outline {
  display: none;
}
.srch ::v-deep .v-input__control .v-field--variant-outlined {
  border-radius: 30px; border: 1px #ddd solid;
}
.srch ::v-deep .v-input__control .v-field--active {
  border: 1px solid #3182f6;
}

/* 검색창 검색하기 버튼 돋보기 색상 변경 */
.searchClickBtn i.mdi-magnify:before {
  color: #fff !important;
}

/*
* 저장된 검색 키워드 목록 관련 css
*/
/* 1. 점선 */
.custom-border1 {
  position: relative;
  width: 1px; /* div의 너비 */
  border-left: 1px dashed black;
}
.custom-border2 {
  position: relative;
  width: 1px; /* div의 너비 */
  height: 15px;
  border-left: 1px dashed black;
}
.custom-border1::before {
  content: "";
  position: absolute;
  left: 3px;
  top: 25%;
  transform: rotate(90deg); /* 정확한 중앙 정렬 */
  width: 1px;
  height: 8px;
  border-left: 1px dashed black;
}
.custom-border2::before {
  content: "";
  position: absolute;
  left: 3px;
  bottom: -4px;
  transform: rotate(90deg); /* 정확한 중앙 정렬 */
  width: 1px;
  height: 8px;
  border-left: 1px dashed black;
}
.v-theme--darkTheme .custom-border1,
.v-theme--darkTheme .custom-border2,
.v-theme--darkTheme .custom-border1::before,
.v-theme--darkTheme .custom-border2::before {
  border-left: 1px dashed white;
}
/* 저장된 검색 키워드 텍스트 */
.keyword-text {
  white-space: normal; /* 기본적인 줄바꿈 허용 */
  word-wrap: break-word; /* 단어 단위에서 줄바꿈 */
  overflow-wrap: break-word; /* 영역 크기를 초과하면 줄바꿈 */
  word-break: break-word; /* 연속된 긴 문자열도 줄바꿈 */
  font-size: 15px;
  cursor: pointer;
  margin : 0 4px;
}
.keyword-text.one-keyword {
  color: black;
}
.v-theme--darkTheme .keyword-text.one-keyword {
  color: white;
}
/* 저장된 검색 키워드 열고 닫기 시.. v-expand-transition태그와 같이 사용됨. */
.expandable-list {
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
  max-height: 200px;
  opacity: 1;
  overflow: hidden;
}
.fade-divider {
  transition: opacity 3s ease-in-out;
}
.fade-divider[v-show="false"] {
  opacity: 0;
}
/* 그룹 관리 내 아이콘 색상 변경 */
::v-deep(.group-setting .mdi:before) {
  color: #3182f6 !important;
}
.group-setting:hover {
  transition: 0.3s ease-in-out;
  background-color: #f5f5f5;
}

.keyword-history-text {
  white-space: normal; /* 기본적인 줄바꿈 허용 */
  word-wrap: break-word; /* 단어 단위에서 줄바꿈 */
  overflow-wrap: break-word; /* 영역 크기를 초과하면 줄바꿈 */
  word-break: break-word; /* 연속된 긴 문자열도 줄바꿈 */
}

/* === 기사목록 칩: 옵션 1개일 때만 완전 타원형 === */
/* 이 규칙은 '모양(border-radius)'만 덮어쓰고
   색상/배경은 txt-co, tab 스타일에서 그대로 가져가게 둠. */
.nestedDrawerChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip) {
  border-radius: 9999px !important;
}
/* first-child / last-child 규칙보다 더 강하게 잡아주기 위해 한 번 더 명시 */
.nestedDrawerChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip:first-child),
.nestedDrawerChipGroup.single-option ::v-deep(.v-slide-group__container.tab .v-chip:last-child) {
  border-radius: 9999px !important;
}

</style>
